export function noop(): void {
  // nothing to do
}
